import React, { useState, useRef } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import SendIcon from '@mui/icons-material/Send';
import { useAnda } from './AndaContext';
import { sendChatStream, getChatHistory } from '../../api/andaApi';
import toastAlert from '../../js/Base/ToastAlert';
import './anda.scss';

const SUGGESTED_QUESTIONS = [
  '彙整當前整體的合規態勢',
  '最需立即處理的威脅',
  '比對本月與上月報告，是否有重複性問題或是新增風險',
  '請幫我做一個近三個月趨勢折線圖',
  '請幫我做一個近三個月高風險項目數量趨勢折線圖',
];

export default function AndaChatInput() {
  const {
    threadId,
    addMessage,
    setThreadId,
    setIsStreaming,
    setStreamingThreadId,
    updateStreamingContent,
    addStreamingImage,
    finishStreaming,
    setHistoryList,
  } = useAnda();
  const [input, setInput] = useState('');
  const [sending, setSending] = useState(false);
  const inputRef = useRef(null);

  const projectId = Number(localStorage.getItem('project_id')) || null;
  const acctNo = Number(localStorage.getItem('user_id')) || null;
  const userName = localStorage.getItem('user_name') || '';

  const sendMessage = async (text) => {
    const content = (text || input).trim();
    if (!content) return;
    if (!projectId) {
      toastAlert.autoClose(true).showError('請先選擇專案');
      return;
    }
    if (!acctNo) {
      toastAlert.autoClose(true).showError('請先登入');
      return;
    }

    setSending(true);
    setInput('');
    setIsStreaming(true);
    setStreamingThreadId(threadId || undefined);
    addMessage({ role: 'user', content });

    let fullText = '';
    let lastResponseId = null;
    let streamingThreadId = threadId || undefined;
    const streamedImages = [];
    try {
      const newThreadId = await sendChatStream({
        project_id: projectId,
        query_content: content,
        acct_no: acctNo,
        thread_id: threadId || undefined,
        user_name: userName || undefined,
        onEvent: (event) => {
          if (event.event === 'thread_id' && event.thread_id) {
            setThreadId(event.thread_id);
            setStreamingThreadId(event.thread_id);
            streamingThreadId = event.thread_id;
          } else if (event.event === 'created' && event.response_id) {
            lastResponseId = event.response_id;
          } else if (event.event === 'delta' && event.content) {
            fullText += event.content;
            updateStreamingContent(fullText);
          } else if (event.event === 'completed' && event.text) {
            fullText = event.text;
          } else if (event.event === 'image' && event.data) {
            const img = { data: event.data, mime_type: event.mime_type || 'image/png' };
            streamedImages.push(img);
            addStreamingImage(img);
          } else if (event.event === 'error') {
            toastAlert.autoClose(true).showError(event.message || '發生錯誤');
          }
        },
      });
      if (newThreadId) setThreadId(newThreadId);
      if (projectId && acctNo) {
        getChatHistory({ acct_no: acctNo, project_id: projectId })
          .then(setHistoryList)
          .catch(() => {});
      }
    } catch (err) {
      toastAlert.autoClose(true).showError(err.message || '發送失敗');
      if (streamingThreadId == null || threadId === streamingThreadId) {
        addMessage({ role: 'assistant', content: '抱歉，發生錯誤，請稍後再試。' });
      }
    } finally {
      finishStreaming(fullText, lastResponseId, streamingThreadId, streamedImages);
      setSending(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMessage(input);
  };

  const handleSuggestedClick = (q) => {
    sendMessage(q);
  };

  return (
    <div className="anda-chat-input-wrap">
      <Form onSubmit={handleSubmit}>
        <InputGroup>
          <Form.Control
            ref={inputRef}
            placeholder="詢問安答問題"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            disabled={sending}
          />
          <Button
            type="submit"
            variant="success"
            disabled={sending || !input.trim()}
            className="anda-send-btn"
            aria-label="送出"
          >
            <SendIcon sx={{ fontSize: 20 }} />
          </Button>
        </InputGroup>
      </Form>
      <div className="anda-suggested">
        {SUGGESTED_QUESTIONS.map((q, i) => (
          <button
            key={i}
            type="button"
            className="anda-suggested-chip"
            onClick={() => handleSuggestedClick(q)}
            disabled={sending}
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
